import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import CustomerOrders from "@/pages/CustomerOrders";
import ProductDetail from "@/pages/ProductDetail";
import ThankYou from "@/pages/ThankYou";
import { CartDrawer } from "@/components/CartDrawer";
import { CheckoutModal } from "@/components/CheckoutModal";

import { AnimatePresence } from "framer-motion";
import { PageTransition } from "@/components/PageTransition";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
      setTimeout(() => window.__lenis?.resize(), 100);
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/producto/:id" element={<PageTransition><ProductDetail /></PageTransition>} />
        <Route path="/login" element={<PageTransition><Login /></PageTransition>} />
        <Route path="/admin" element={<PageTransition><Admin /></PageTransition>} />
        <Route path="/mis-pedidos" element={<PageTransition><CustomerOrders /></PageTransition>} />
        <Route path="/gracias" element={<PageTransition><ThankYou /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 0.9, smoothWheel: true, wheelMultiplier: 1.0 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AnimatedRoutes />
            <CartDrawer />
            <CheckoutModal />
          </BrowserRouter>
          <Toaster theme="dark" position="bottom-left" toastOptions={{ style: { background: "#111111", border: "1px solid rgba(201,169,106,0.3)", color: "#fff" } }} />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
